export default __webpack_public_path__ + "static/media/inner-course-symb.3af4b39e.svg";